import types from "./types";

export default {

	update(data) {
		return {
			type: types.UPDATE,
			data
		};
	}

};
